
export const SignupSelector = (state) => state.form.signup;
export const SignupFormSelector = (state) => state.form.forms.signup;
